export const SHADOW = 'none'
